import { render, staticRenderFns } from "./UserLink.vue?vue&type=template&id=009cae80&scoped=true&"
import script from "./UserLink.vue?vue&type=script&lang=ts&"
export * from "./UserLink.vue?vue&type=script&lang=ts&"
import style0 from "./UserLink.vue?vue&type=style&index=0&id=009cae80&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "009cae80",
  null
  
)

export default component.exports